<template>
    <b-card no-body>
        <b-card-header>
            <slot name="materialGroupHeader" v-bind="materialGroup"></slot>
            <template v-if="materialGroup.MaterialGroupDescription.length > 0">
                {{ materialGroup.MaterialGroupDescription }}
            </template>
        </b-card-header>
        <b-card-body class="p-1 w-auto">
            <b-table-simple>
                <b-tr>
                    <b-td v-if="hasHeaderSlot"></b-td>
                    <b-th v-for="field in filteredFields" :key="field.key">
                        {{ field.label }}
                    </b-th>
                </b-tr>
                <model-row :model="model" :fields="filteredFields" v-for="model in models" :key="model.PcnCatalogNumber">
                    <template #rowHeader="model">
                        <slot name="rowHeader" v-bind="model"></slot>
                    </template>
                </model-row>
            </b-table-simple>
        </b-card-body>
    </b-card>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'

import LoadingText from '@/components/utility/loading-text.vue'

import MxSite from '@/mixins/site'

import ModelRow from './row.vue'

import { MaterialGroup } from '@/store/search/types'
import { Model } from '@/store/model-viewer/types'

@Component({
  components: {
    'loading-text': LoadingText,
    'model-row': ModelRow,
  },
})
export default class extends MxSite {
  @Prop()
  public materialGroup!: MaterialGroup

  @Prop()
  public models!: Model[]

  @Prop({ default: () => [] })
  public fields!: any[]

  @Prop()
  public customerNumber!: string

  get hasHeaderSlot() {
    return (
      Boolean(this.$slots.rowHeader) ||
      Boolean(typeof this.$scopedSlots.rowHeader === 'function')
    )
  }

  get filteredFields() {
    const models = this.models
    const displayCustomerMaterialNumber = models.some(m => m.CustomerMaterials?.some(c => c.CustomerNumber === this.customerNumber))
    if (!displayCustomerMaterialNumber) {
      return this.fields.filter(f => f.key !== 'CustomerMaterials')
    }
    return this.fields
  }
}
</script>
